<template>
  <div class="CourseSelect-container">
    <el-select
      v-model="value"
      ref="select"
      placeholder="请选择课程，可输入关键字搜索"
      filterable
      clearable
      prefix-icon="el-icon-search"
      :filter-method="searchCourse"
      :disabled="disabled"
      :style="tcfstyle"
      @clear="clearSelect">
      <el-option :value="value" :label="changeLabel" style="height: auto;padding: 0;">
        <el-table
          :data="tableData"
          :show-header="false"
          :row-style="{cursor: 'pointer'}"
          @row-click="openDetails"
          style="width: 100%">
          <el-table-column
            label="#"
            align="center"
            width="100">
            <template slot-scope="scope">
              <el-image
                style="width: 75px;height: 42px"
                :src="scope.row.img_url"
                fit="cover"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            label="课程名称"
            min-width="500">
            <template slot-scope="scope">
              <div style="font-weight: 400;">{{scope.row.cname}}</div>
              <div style="font-size: 12px;color:#909399">
                <span style="color:#409EFF" v-if="scope.row.type===0"><i class="el-icon-video-play"></i> 视频</span>
                <span style="color:#E6A23C" v-if="scope.row.type===1"><i class="el-icon-headset"></i> 音频</span>
                <span style="color:#67C23A" v-if="scope.row.type===2"><i class="el-icon-reading"></i> 电子书</span>
                <span style="margin-left: 10px;font-weight: normal">{{scope.row.two_name}} / {{scope.row.three_name}}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-option>
      <el-pagination
        v-if="total>0"
        style="padding:10px"
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-select>
  </div>
</template>

<script>
import { getCourseList } from '@/api/study/course'
import { getCourseByCid } from '@/api/work'

export default {
  name: 'CourseSelect',
  props: {
    oldcid: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tcfstyle: {
      type: String,
      default: 'width: 100%'
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      filterText: '',
      value: '',
      changeLabel: ''
    }
  },
  created() {
    this.getData()
    if (this.oldcid !== null && this.oldcid !== '' && this.oldcid !== undefined) {
      getCourseByCid({ cid: this.oldcid }).then(response => {
        this.value = response.data.cid
        this.changeLabel = response.data.cname
        this.$emit('input', { cid: response.data.cid, name: response.data.cname, type: response.data.type })
      }).catch(() => {})
    }
  },
  methods: {
    getData() {
      this.loading = true
      const data = {
        mark: 1,
        content: this.filterText,
        page: this.currentPage,
        limit: this.pageSize
      }
      getCourseList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    clearSelect() {
      this.filterText = ''
      this.value = ''
      this.changeLabel = ''
      this.$emit('input', null)
    },
    searchCourse(val) {
      this.filterText = val
      this.currentPage = 1
      this.getData()
    },
    openDetails(data) {
      this.value = data.cid
      this.changeLabel = data.cname
      this.$emit('input', { cid: data.cid, name: data.cname, type: data.type })
      // this.$emit('setCourse', data)
      this.$refs.select.blur()
    }
  }
}
</script>
<style lang="scss" scoped>
  .CourseSelect-container{
    .el-table::before{
      height: 0!important;
    }
    .el-pagination{
      margin-top: 20px;
    }
  }
</style>
